import { BarChartRounded } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import { DateTime } from "luxon";
import { useCallback, useState } from "react";
import { HeaderLayout, IconLink } from "src/components";
import { Paths } from "src/constants";
import { setTitlePrefix } from "src/utilities";
import { AppUsageDateRangePicker } from "./AppUsageDateRangePicker";
import { AppUsageSummarySection } from "./AppUsageSummarySection";
import { PageMetricsTable } from "./PageMetricsTable";

type DateParams = {
  startDateUtc: string;
  endDateUtc: string;
};

const AppUsageReportPage = () => {
  setTitlePrefix("App Usage Report");
  const [dateParams, setDateParams] = useState<DateParams>(() => ({
    startDateUtc: DateTime.now().minus({ days: 30 }).startOf("day").toISO(),
    endDateUtc: DateTime.now().endOf("day").toISO(),
  }));

  const handleDateParamsChange = useCallback((params: DateParams) => {
    setDateParams(params);
  }, []);

  return (
    <HeaderLayout
      title={
        <Stack>
          <IconLink href={Paths.Reports} startIcon={<BarChartRounded fontSize="small" />}>
            Reports
          </IconLink>
          <Typography variant="h3">App Usage</Typography>
          <Typography>Daily page view activity, session duration, and visitor trends.</Typography>
        </Stack>
      }
      toolbar={<AppUsageDateRangePicker onChange={handleDateParamsChange} />}
    >
      <Stack spacing={{ xs: 0.5, sm: 1 }}>
        <AppUsageSummarySection dateParams={dateParams} />
        <PageMetricsTable dateParams={dateParams} />
      </Stack>
    </HeaderLayout>
  );
};

export { AppUsageReportPage };
